import { Component, OnInit, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NotificationService } from './notification.service';
import { NotificationDialogComponent } from './notification-dialog/notification-dialog.component';
import {  FilterChangedEvent, GridApi, GridOptions , IGetRowsParams} from 'ag-grid-community';
import { notificationtooltip } from 'src/app/core/grid-renderer/notification-tooltip';
import { CellsComponent } from 'src/app/core/grid-renderer/cells/cells.component';
import { catchError, EMPTY, Observable, of, tap } from 'rxjs';
import { style } from '@angular/animations';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AgGridAngular } from 'ag-grid-angular';
import * as moment from 'moment';

import { MatDialogRef, MatDialog } from '@angular/material/dialog';
@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: false // NOSONAR
})
export class NotificationComponent implements OnInit, AfterViewInit {
  handleError(_err: any): any {
    throw new Error('Method not implemented.');
  }
  notificationFilterForm: FormGroup;
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;
  @ViewChild('notificationDialog') notificationDialog!: TemplateRef<any>;
  dialogRef!: MatDialogRef<any>;
  dialogData = { title: '', message: '' };
  rowData: any[] = []; // Data for the grid
  totalRecords = 0;
  pageSize = 10;  // Number of rows per page
  currentPage = 1; // Current page
  defaultColDef: any;
  context: any;
  rowClassRules: any;
  tooltipShowDelay = 0;
  tooltipHideDelay = 9000;
  tooltipMouseTrack = true;
  public getRowStyle: any;
  remoteGridBinding = this;
  dynamicHeight: any;
  detailCellRendererParams;
  paginationPageSize: any = 20;
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  icons;
  gridOptions: any = { enableCellTextSelection: true, };
  columnDefs = [];
  
  gridApi: any;
  filteredNotifications: any[] = [];
  getData = (params: IGetRowsParams) => {
    return this.notificationService.getNotifications({...params, pageSize: this.pageSize})
      .pipe(
        tap(response => params.successCallback(response.tnotificationsDTOS, response.navOptions?.totalRecords)),
        catchError(err => {
          if (this.getDataError) {
            this.getDataError(err);
          }
          params.failCallback();
          return EMPTY;
        })
      );
  };

 constructor(
    private readonly fb: FormBuilder,
    private readonly notificationService: NotificationService,
      private readonly dialog : MatDialog
  ) {
    this.notificationFilterForm = this.fb.group({
      name: [''],
      userIds: ['']
    });
    this.rowClassRules = {
      'notification-row-even': 'node.rowIndex % 2 == 0',  // NOSONAR
      'notification-row-odd': 'node.rowIndex % 2 != 0', // NOSONAR
    };
  }
  
  getDataError?: (err: any) => void; // This code is not required
  
  onGridReady(params: any) {
    this.gridOptions.api = params.api;
    this.gridOptions.domLayout = 'autoHeight';
    this.gridOptions.suppressHorizontalScroll = true;
  
    this.gridApi = params.api;
  
    this.gridApi.sizeColumnsToFit();
  
  }
  
  sizeToFit() {
    this.gridApi?.sizeColumnsToFit();
  }
  onFirstDataRendered(event) {
    event.api.resetRowHeights();
  }
  ngOnInit() : void {
    this.dynamicHeight = 0.665 * window.innerHeight;
    this.columnDefs = [
      { field: 'name', headerName: 'Name', 
        floatingFilterComponentParams: { suppressFilterButton: true },
        minWidth: 10,
        //maxWidth: 100,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        sortable: true,
        unSortIcon: true,
        autoHeight: true,
      },
      { field: 'disabled', headerName: 'Disable', 
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
            floatingFilter: true,
            sortable: true,
            unSortIcon: true,
            autoHeight: true,
      },
      { field: 'updatedBy', headerName: 'Updated By', 
        
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
            floatingFilter: true,
            sortable: true,
            unSortIcon: true,
            autoHeight: true,
      },
      { field: 'updatedDate', headerName: 'Updated Date', 
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
            floatingFilter: true,
            sortable: true,
            unSortIcon: true,
            autoHeight: true,
            comparator: this.dateComparator
          },
      { field: 'createdBy', headerName: 'Created By', 
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
            floatingFilter: true,
            sortable: true,
            unSortIcon: true,
            autoHeight: true,},
      { field: 'lastBroadcast', headerName: 'Last Broadcast', 
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
            floatingFilter: true,
            sortable: true,
            unSortIcon: true,
            autoHeight: true,},
      { field: 'userIds', headerName: 'User Ids', unSortIcon: true, floatingFilterComponentParams: { suppressFilterButton: true },filter: 'agTextColumnFilter',
      floatingFilter: true , autoHeight: true, sortable: true, flex:3 ,tooltipComponent: notificationtooltip, 
        tooltipField: 'userIds',cellStyle: { 'text-overflow':'ellipsis','white-space':'nowrap', 'overflow': 'hidden', 'padding': 0 }},
    
      {
        headerName: 'Action',
        cellRenderer: (params: any) => {
          const container = document.createElement('div');
          container.style.display='flex';
          container.style.gap='5px';
    
          const editButton = document.createElement('button');
          editButton.innerHTML = '✏️';
          editButton.classList.add('edit-btn');
          editButton.style.border='none';
          editButton.addEventListener('click', () => {
            this.getEdit(params.data);
            console.info('Edit clicked', params.data);
          });
    
          const deleteButton = document.createElement('button');
          deleteButton.innerHTML = '🗑️';
          deleteButton.classList.add('delete-btn');
          deleteButton.style.border='none';
          deleteButton.addEventListener('click', () => {
            console.info('Delete clicked', params.data);
            this.deleteNotification(params.data);
          });
    
          container.appendChild(editButton);
          container.appendChild(deleteButton);
    
          return container;
        },
        width: 150
      }
      
    ];
    this.icons = {
      sortUnSort: '<img src="assets/images/Icon awesome-sort.svg">',
    };

    this.loadNotifications();
  }
  loadNotifications(){
    this.notificationService.getNotificationsNew()?.subscribe(
      (response) => {
        // Directly map the response to apply the date formatting
        this.filteredNotifications = response.tnotificationsDTOS.map((item: any) => {
          return {
            ...item,
            updatedDate: this.dateFormatter(item.updatedDate), // Format the date
          };
        });
        this.rowCount = this.filteredNotifications.length;
        console.info("this.filteredNotifications" + this.filteredNotifications )
        
      },
      (_error) => {
        // do nothing 
      }
    );
  }
  onModelUpdated(){
    this.sizeToFit();
  }
  ngAfterViewInit() {
    console.info('some')
  }

  refreshGrid() {
    if (this.gridApi) {
      this.loadNotifications();
      this.gridApi.applyTransaction({ add: this.filteredNotifications }); 

    }
  }

  dataSource: any = {
    getRows: (params: any) => {
      this.notificationService
        .getNotifications({...params, pageSize: this.pageSize})
        .pipe(
          tap((data): any =>
            params.successCallback(data?.tnotificationsDTOS, data?.navOptions?.totalRecords)
          ),
          catchError(err => this.handleError(err))
        )
        .subscribe();
    }
  };

  dataSourceFilter: any = {
    getRows: (params: any) => {
      this.notificationService
        .filterNotifications(this.notificationFilterForm?.value, {...params, pageSize: this.pageSize})
        .pipe(
          tap((data): any =>
            params.successCallback(data?.tnotificationsDTOS, data?.navOptions?.totalRecords)
          ),
          catchError(err => this.handleError(err))
        )
        .subscribe();
    }
  };

  /**
   * Reset filters and reload original data
   */
  resetFilter() {
    this.notificationFilterForm.reset();
    this.refreshGrid();
  }

  /**
   * Add a new notification
   */
  addNotification(notification: any) {
    this.notificationService.addNotification(notification).subscribe({
      next: (_response) => {
        console.info('Notification added successfully');
        this.notification('Notification', 'Created Successfully');
        this.refreshGrid();
      },
      error: (err) => {
        console.info('Error adding notification:', err);
        this.notification('Notification', 'Error adding notification');
      }
    });
  }

  /**
   * Edit an existing notification
   */
  edit(notification: any) {
    this.notificationService.editNotification(notification).subscribe({
      next: () => {
        console.info('Notification updated successfully');
        this.notification('Notification', 'Updated Successfully');
        this.refreshGrid();
      },
      error: (_err) => {
        this.notification('Notification', 'Error while updating Notification');
      }
    });
  }

  /**
   * Delete a notification
   */
  delete(notification: any) {
    this.notificationService.deleteNotification(notification.id).subscribe({
      next: (response: any) => {
        console.info('Notification deleted successfully');
        const successText = (response ?? '').toString().trim() || 'Notification deleted successfully';
        this.notification('Notification', successText);
        this.refreshGrid();
      },
      error: (err) => {
        console.info('Error deleting notification:', err);
        const errorText =
          err?.error?.message ??
          err?.error ??
          err?.message ??
          'Error deleting notification';
        this.notification('Notification', errorText);
      }
    });
  }

  deleteNotification(notification: any) {
    this.openConfirmationDialog(
      'Delete Notification',
      `Are you sure you want to delete "${notification.name}"?`,
      () => {
        this.delete(notification);
      }
    );
  }

  editNotification(notification: any) {
    this.openConfirmationDialog(
      'Edit Notification',
      `Are you sure you want to edit "${notification.name}"?`,
      () => {
        this.edit(notification);
      }
    );
  }
  /**
   * Open Confirmation Dialog for Edit/Delete
   */
  openConfirmationDialog(title: string, message: string, onConfirm: () => void) {
    this.dialogData = { title, message };
    this.dialogRef = this.dialog.open(this.confirmationDialog,{
      width: '300px',
      height: '150px',
    });

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        onConfirm();
      }
    });
  }

  /**
   * Open Notification Dialog
   */
  openNotificationDialog(notification?: any): void {
    let data: any = {...notification};
    if (!notification) {
      data = {
        notificationType: 'AET', name: '', disabled: '', rules: [], subscribers: []
      }
    } 
    const dialogRef = this.dialog.open(NotificationDialogComponent, {
      width: '800px',
      height:'650px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (notification) {
          this.edit(result);
        } else {
          this.addNotification(result);
        }
      }
    });
  }
  /**
   * Get Edit Data existing notification
   */
  getEdit(notification: any) {
    this.notificationService.getEditNotification(notification?.id).subscribe({
      next: (data: any) => {
        const response:any = {
          ...data?.notification,rules:data?.rules, subscribers:data?.subscribers,
        }
        this.openNotificationDialog(response);
      },
      error: (err) => {
        console.info('Error updating notification:', err);
      }
    });
}
  /**
   * Show notification message
   */
  notification(title: any, message: any) {
    this.dialogData = { title, message };
    this.dialogRef = this.dialog.open(this.notificationDialog, {
      width: '300px',
    });
  }
  
  /**
   * Filter notifications
   */
  filterData() {
    if (this.gridApi) {
      this.notificationService.filterNotificationsNew(this.notificationFilterForm?.value)?.subscribe(
        (response) => {
          // Directly map the response to apply the date formatting
          this.filteredNotifications = response.tnotificationsDTOS.map((item: any) => {
            return {
              ...item,
              updatedDate: this.dateFormatter(item.updatedDate), // Format the date
            };
          });
          this.rowCount = this.filteredNotifications.length;
        },
        (_error) => {
          //do nothing
        }
      );
    }
  }

  goToNexpage() {
    this.gridApi.paginationGoToNextPage();
  }
  goToPreviousPage() {
    this.gridApi.paginationGoToPreviousPage();
  }
  goToFirstPage() {
    this.gridApi.paginationGoToFirstPage();
  }
  goToLastPage() {
    this.gridApi.paginationGoToLastPage();
  }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();

    if (this.currentPageNo == 0) {  // NOSONAR
      this.currentPageBoolean = true;
    } else {
      this.currentPageBoolean = false;
    }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage =
      Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) {  // NOSONAR
      this.isLastPageFound = true;
    } else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  onPaginationChanged() {
    if (this.gridApi) {
      this.setText(
        '#lbCurrentPage',
        this.gridApi.paginationGetCurrentPage() + 1
      );
      this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
      this.setLastButtonDisabled(!this.gridApi.paginationIsLastPageFound());
    }
  }
  onPageSizeChanged(event: any) {
    if (event.target.value == 'ALL') {  // NOSONAR
      this.paginationPageSize = event.target.value;
    } else {
      this.paginationPageSize = event.target.value;
      this.gridApi?.paginationSetPageSize(Number(event.target.value));
    }
  }
  setText(selector: string, text: any) {
    if (this.rowCount > 0) {
      (document.querySelector(selector) as any).innerHTML = text;
    }
  }
  setLastButtonDisabled(_disabled: boolean) {
    this.isLastPageFound = true;
  }

  onPageSizeChange(newSize: any) {
    const pageSize = Number(newSize?.target?.value);
    this.pageSize = pageSize;
    if (this.gridOptions.api) {
      this.gridOptions.api.paginationSetPageSize(pageSize);
    }
  }

  onFilterChanged(params: FilterChangedEvent): void {
    this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
    this.rowCount = params.api?.getDisplayedRowCount();
    const check = document.getElementById('lbTotalPages').innerHTML;
    if(this.rowCount == 0 && Number(check) == 0 ){  // NOSONAR
      document.getElementById('lbCurrentPage').innerHTML='0';
    }
    }

    dateFormatter(res)
  {
    return res ? moment.utc(res).format('MM/DD/YYYY HH:mm') : null;
  }

    dateComparator(date1, date2) {
      const date1Number = monthToComparableNumber(date1);
      const date2Number = monthToComparableNumber(date2);
      if (date1Number == null && date2Number == null) {  // NOSONAR
        return 0;
      }
      if (date1Number == null) {  // NOSONAR
        return -1;
      }
      if (date2Number == null) {  // NOSONAR
        return 1;
      }
      return Number(date1Number) - Number(date2Number);
    }
  
}
function monthToComparableNumber(date) {
  if (date == undefined || date == null || date.length != 16) { // NOSONAR
    return null;
  }
  const minNumber = Number.parseInt(date.substring(14, 16));
  const hourNumber = Number.parseInt(date.substring(11, 13));

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));

  return yearNumber * 100000000 + monthNumber * 1000000 + dayNumber * 10000 + hourNumber * 100 + minNumber;
}